// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"95d36eb1","314":"3720562e","422":"55a051f5","869":"c45f7af0","982":"b1b31a90"}[chunkId] + ".chunk.js";
};